'use strict';
/*
  chrome — Y2K liquid metal. Polished chrome type with a two-tone steel/sky
  gradient and a hard "horizon" band, a dark bevel + specular top sliver, on a
  deep navy backdrop with a slow moving sheen. Emphasis adds a cyan rim-glow.
*/
const { FONTS } = require('../lib/draw');
const { layoutCue } = require('./_common');

const palette = { bg: '#070b16', fg: '#dfe9f5', accent: '#ff43c6', accent2: '#34e0ff', ink: '#0a0e1a' };

function init(st){ st.s.font = st.tk.registerFamily('ForgeChrome', FONTS.arialBlack) || undefined; st.s.pop = 0; st.s.sheen = 0; }
function onBeat(st, power){ st.s.pop = Math.min(1, st.s.pop + power * 0.5); }

function chromeGrad(ctx, px){
  const g = ctx.createLinearGradient(0, -px * 0.55, 0, px * 0.45);
  g.addColorStop(0.00, '#cdd9e6'); g.addColorStop(0.20, '#ffffff'); g.addColorStop(0.46, '#7d93b0');
  g.addColorStop(0.50, '#2f3e58'); g.addColorStop(0.55, '#9fb4cf'); g.addColorStop(0.80, '#eef4fb'); g.addColorStop(1.00, '#a9b9cd');
  return g;
}

function background(ctx, st){
  const { W, H } = st; st.s.pop *= 0.86; st.s.sheen += 0.004;
  if (!st.overlayMode) {
    const g = ctx.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, '#0c1426'); g.addColorStop(0.6, '#070b16'); g.addColorStop(1, '#03050c');
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
    const e = (st.spectrum ? st.energy || 0 : 0);
    const sx = st.CX + Math.sin(st.s.sheen) * W * 0.3, sy = H * 0.36 + Math.cos(st.s.sheen * 1.3) * H * 0.1;
    const rad = ctx.createRadialGradient(sx, sy, 30, sx, sy, W * (0.6 + e * 0.2));
    rad.addColorStop(0, 'rgba(120,170,230,' + (0.10 + e * 0.08).toFixed(3) + ')'); rad.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = rad; ctx.fillRect(0, 0, W, H);
  } else {
    const g = ctx.createLinearGradient(0, H * 0.5, 0, H);
    g.addColorStop(0, 'rgba(3,6,16,0)'); g.addColorStop(1, 'rgba(3,6,16,0.55)');
    ctx.fillStyle = g; ctx.fillRect(0, H * 0.5, W, H * 0.5);
  }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  const pop = emph ? 1 + st.s.pop * 0.06 : 1;
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl * pop, scl * pop);
  ctx.font = tk.font(px, 900, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.fillStyle = 'rgba(150,180,220,0.5)'; ctx.fillText(T, 0, 0); ctx.restore(); return; }
  ctx.fillStyle = 'rgba(6,10,20,0.92)'; ctx.fillText(T, 0, px * 0.05);          // bevel / drop
  ctx.lineJoin = 'round'; ctx.lineWidth = px * 0.06; ctx.strokeStyle = '#10182a'; ctx.strokeText(T, 0, 0);
  ctx.fillStyle = chromeGrad(ctx, px); ctx.fillText(T, 0, 0);                    // chrome
  ctx.save(); ctx.beginPath(); ctx.rect(-2000, -px * 0.55, 4000, px * 0.28); ctx.clip();  // specular top sliver
  ctx.globalAlpha = alpha * 0.45; ctx.fillStyle = '#ffffff'; ctx.fillText(T, 0, -px * 0.015); ctx.restore();
  if (emph) { ctx.shadowColor = palette.accent2; ctx.shadowBlur = px * 0.28; ctx.lineWidth = px * 0.03; ctx.strokeStyle = palette.accent2; ctx.strokeText(T, 0, 0); }
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.74 : 'center';
  layoutCue(ctx, st, { sizes: { big: 146, mid: 118, small: 64 }, anchor, safeW: 0.88, reveal: 0.26, stagger: 0.05, trail: 2, trans: 0.18, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  ctx.save(); ctx.globalAlpha = 0.04; ctx.globalCompositeOperation = 'overlay'; ctx.drawImage(tk.grain(), -Math.random() * 100, -Math.random() * 100); ctx.restore();
  ctx.drawImage(tk.vignette(st.overlayMode ? 0.5 : 0.7, 330), 0, 0);
  if (!st.overlayMode) {
    const pg = ctx.createLinearGradient(0, 0, st.W, 0);
    pg.addColorStop(0, palette.accent2); pg.addColorStop(1, '#ffffff');
    ctx.fillStyle = pg; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6);
  }
}

module.exports = { id: 'chrome', label: 'Chrome · liquid metal', palette, init, background, drawCue, overlay, onBeat, paintToken };
